import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';

export default function QuickReviewPage() {
  const { outlineId } = useParams();
  const iframeRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    const fetchHtml = async () => {
      const { data, error } = await supabase
        .from('topics')
        .select('quick_review_html')
        .eq('id', outlineId)
        .single();

      if (error) {
        console.error('Error loading quick review:', error);
        setHtmlContent('<p style="padding:2rem">⚠️ Error loading content.</p>');
      } else {
        setHtmlContent(data.quick_review_html || '<p style="padding:2rem">ℹ️ No content available.</p>');
      }

      setLoading(false);
    };

    fetchHtml();
  }, [outlineId]);

  useEffect(() => {
    if (!loading && iframeRef.current && htmlContent) {
      const iframeDoc = iframeRef.current.contentDocument || iframeRef.current.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(htmlContent);
      iframeDoc.close();
    }
  }, [loading, htmlContent]);

  return (
    <div className="w-full h-screen">
      {loading ? (
        <div className="p-6 text-center text-gray-500">Loading preview...</div>
      ) : (
        <iframe
          ref={iframeRef}
          title="Quick Review Preview"
          className="w-full h-full border-none"
          sandbox="allow-scripts allow-same-origin"
        />
      )}
    </div>
  );
}
